export default __webpack_public_path__ + "static/media/icon-card-mx-flight-hours-limit.d2e2f849.svg";